import { createTRPCReact, type CreateTRPCReact } from '@trpc/react-query';
import type {
  FileRouter,
  ReactQueryOptions,
  RouterInputs,
  RouterOutputs,
} from '@duke-hq/svc-files/web-api';

export const trpcFiles: CreateTRPCReact<FileRouter, unknown> = createTRPCReact<FileRouter>();

export type FilesTrpcClient = typeof trpcFiles;

export type { ReactQueryOptions, RouterInputs, RouterOutputs };
